import React, { useEffect, useMemo, useState } from 'react';
import { EuiButton, EuiFieldSearch, EuiFilterButton, EuiFilterGroup, EuiFlexGroup, EuiFlexItem, EuiLink, EuiLoadingSpinner, EuiPanel, EuiSelect, EuiSwitch, EuiToken } from "@elastic/eui";
import { AnioActual, AniosFacturacionExpatriados, MesActual, optionsMesesSelectorSimple } from '../../../../../../shared/utils/constants';
//import '../styles.css';

const Anios = [{value: AnioActual-1, text:(AnioActual-1).toString()},{value: AnioActual, text:AnioActual.toString()}];//AniosFacturacionExpatriados().map((a:any)=>{ return {value: a, text:a.toString()} })
const Meses = optionsMesesSelectorSimple();
const _tipos = [{label:'Doble Ret.',value:'dr'}, {label:'Doble Dest.',value:'dd'}, {label:'Menos 1 Mes.',value:'mm'}];
//const _tiposEmpleado = [{label:'Estructura',value:'E'}, {label:'Obra',value:'O'}];

export const AjustesCostosExpatriadosSidebarScreen = (props:any) =>{
    
    const {data, handleFilter,handleUserClick,selected, onChangeFilter, isLoading} = props; //
   
    const [anio, setAnio] = useState(AnioActual);
    const [mes, setMes] = useState(MesActual.toString());
    const [tipo, setTipo] = useState<any>(undefined);
    const [search, setSearch] = useState('');
    const [esObra, setEsObra] = useState(false);

    useEffect(()=>{
        if(esObra===true) setTipo('o');
    },[esObra])

    useEffect(()=>{
        onChangeFilter({...{anio:anio,mes:Number(mes),tipo:tipo,esObra:esObra}})
    },[anio,mes,tipo,esObra])

    const onFilter = ()=>{
        const filter = {anio:anio,mes:Number(mes),tipo:tipo, esObra:esObra}
        handleFilter(filter);
    }

    const onClick = (sel:any)=>{
        handleUserClick(sel)
    }


    const filterComponent = ()=> (
        <EuiPanel>
            <EuiFlexGroup direction='column'>
                <EuiFlexItem>
                    <EuiFlexGroup>
                        <EuiFlexItem grow={false}>
                        <EuiSelect
                        compressed
                        onChange={(e:any) => {setAnio(parseInt(e.target.value))}}
                        options={Anios}
                        value={anio}
                        />
                    </EuiFlexItem>
                    <EuiFlexItem>
                        <EuiSelect
                        compressed
                        onChange={(e:any)=> {setMes(e.target.value)}}
                        options={Meses}
                        value={mes}
                        />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false} className='chk-switch'>
                        <EuiSwitch compressed label='Obra' checked={esObra} onChange={e=>setEsObra(!esObra)}/>
                    </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiFlexGroup>
                    <EuiFlexItem>
                        <EuiFilterGroup fullWidth>
                            <EuiFilterButton
                            size='s'
                            hasActiveFilters={tipo===_tipos[0].value}
                            onClick={()=>setTipo(_tipos[0].value)}
                            title='Doble Retención'
                            disabled={esObra}
                            >
                            {_tipos[0].label}
                            </EuiFilterButton>
                            <EuiFilterButton
                            size='s'
                            hasActiveFilters={tipo===_tipos[1].value}
                            onClick={()=>setTipo(_tipos[1].value)}
                            title='Doble Destino'
                            disabled={esObra}
                            >
                                {_tipos[1].label}
                            </EuiFilterButton>
                            <EuiFilterButton
                            size='s'
                            hasActiveFilters={tipo===_tipos[2].value}
                            onClick={()=>setTipo(_tipos[2].value)}
                            title='Menos De 1 Mes'
                            disabled={esObra}
                            >
                                {_tipos[2].label}
                            </EuiFilterButton>
                        </EuiFilterGroup>
                    </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiButton size='s'
                    style={{background:'#c6d3f1',color:'#2d20d3'}} 
                    onClick={()=>{onFilter()}} title='Filtrar'>Filtrar</EuiButton>
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiPanel>
    )
    const dataFilter = useMemo(()=>search!=='' ? data && data.filter((f: any) => new RegExp(`${search}.*`, "i").test(f["nombre"])) : data,[search,data])

    const searchComponent = ()=><EuiFieldSearch fullWidth compressed placeholder={'buscar usuario..'} value={search} isClearable onChange={(e)=> setSearch(e.target.value)}/>
    
    const listUsersComponent = ()=> {
        
        return dataFilter.map((u:any)=>{
                const isSelected:boolean = selected!==undefined && (u.idEmpleado===selected.idEmpleado);
                const _classSelected = `item-list-ajuste-expatriado ${isSelected===true?'active':''}`;

                return (<EuiFlexItem grow={false}>
                        <EuiLink
                        className={_classSelected}
                        onClick={() => {onClick(u)}}
                        >
                        <EuiFlexGroup justifyContent='spaceAround' alignItems='center' gutterSize='s'>
                            <EuiFlexItem grow={false}>
                                <EuiToken className={`icono-ajuste-costo-expatriado-${(isSelected ? selected.ajuste === true : u.ajuste==true)?'enabled':'disabled'}`} iconType="gear" size="m" shape="circle" fill='none'/>
                            </EuiFlexItem>
                            <EuiFlexItem>{`${u.nombre}`}</EuiFlexItem>
                        </EuiFlexGroup>
                        </EuiLink>
                </EuiFlexItem>)
        })
    }

    const getLoadList = () => (
        <EuiPanel style={{height:'100%'}}>
            <EuiFlexGroup direction='column' alignItems='center' style={{height:'100%'}}>
                <EuiFlexItem style={{justifyContent:'center'}}>
                    <EuiLoadingSpinner size="xl" />
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiPanel>
    )

    const getSelectorUsers = () => data.length>0 && (
        <EuiPanel style={{height:'100%'}}>
            <EuiFlexGroup direction='column' style={{height:'100%'}}>
                <EuiFlexItem grow={false}>{searchComponent()}</EuiFlexItem>
                <EuiFlexItem style={{overflowY:'auto',overflowX:'hidden'}}>
                    <EuiFlexGroup direction='column' style={{height:'100%'}}>{listUsersComponent()}</EuiFlexGroup>
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiPanel>
    );

    const getContentList = useMemo(()=>(
        isLoading ? getLoadList() : getSelectorUsers()
    ),[isLoading, getLoadList, getSelectorUsers])

    //const dataFilter = useMemo(()=>search!=='' ? sociedades && sociedades.filter((f: any) => new RegExp(`${search}.*`, "i").test(f["sociedad"])) : sociedades,[search,sociedades])
    return (
        <EuiFlexGroup direction='column' style={{height:'100%',overflow:'hidden', margin:'0.5rem'}} gutterSize='s'>
            <EuiFlexItem grow={false}>{filterComponent()}</EuiFlexItem>
            <EuiFlexItem style={{overflow:'hidden'}}>{getContentList}</EuiFlexItem>
        </EuiFlexGroup>
    )
}